import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  disableArchive: boolean
  setArchiveModalOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const Footer = ({ disableArchive, setArchiveModalOpen }: Props) => {
  return (
    <>
      <Button type="primary" disabled={disableArchive} submit>
        {i18n.t('common.archive')}
      </Button>
      <Button type="positive" onClick={() => setArchiveModalOpen(false)}>
        {i18n.t('common.keep')}
      </Button>
    </>
  )
}

export default Footer
